import { DEV_API_URL, parseEnv } from './env-schema';

/**
 * The dev server and the test runner have no `.env` in this repo, so they get
 * the localhost fallback explicitly and only here. A production bundle never
 * reaches this branch — `import.meta.env.DEV` is false — which is what keeps a
 * missing `VITE_API_URL` from turning into a working-looking build that talks
 * to nobody. The real gate is in `vite.config.ts`: it fails the build.
 */
const raw: Record<string, unknown> = { ...import.meta.env };
if (import.meta.env.DEV && !raw.VITE_API_URL) raw.VITE_API_URL = DEV_API_URL;

const parsed = parseEnv(raw);
if (!parsed.success) {
  console.error('[env] invalid Vite env:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid VITE_ public env');
}

export const env = parsed.data;
export const apiBaseUrl = `${env.VITE_API_URL.replace(/\/+$/, '')}/v1`;
